import getLang from 'I18n/utils/getLang';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import unescapedText from 'I18n/utils/unescapedText';
import { useUserInsightsClient } from './useUserInsightsClient';
const RECOMMENDATION_PRIORITY = ['country', 'industry', 'language'];
function buildRecommendationTranslationKey(recommendationKey, recommendationValue) {
  let translationKey = '';
  switch (recommendationKey) {
    case 'country':
      translationKey = `SharedI18nStrings.countryCodes.${recommendationValue}`;
      break;
    case 'industry':
      translationKey = `marketplace-ui-common.industry.${recommendationValue}.sentence`;
      break;
    case 'language':
      translationKey = `SharedI18nStrings.languageNames.${recommendationValue}`;
      break;
    default:
      break;
  }
  return isValidI18nKey(translationKey) ? translationKey : null;
}
export function useFormatRecommendedPartners() {
  var _insightsData$portalI;
  const {
    data: insightsData,
    loading
  } = useUserInsightsClient();
  if (!insightsData) {
    return {
      data: [],
      loading
    };
  }
  const normalizedInsights = {
    country: insightsData.portalInsights && insightsData.portalInsights.hqCountry || insightsData.ipCountry,
    industry: (_insightsData$portalI = insightsData.portalInsights) === null || _insightsData$portalI === void 0 ? void 0 : _insightsData$portalI.industry
  };
  const data = RECOMMENDATION_PRIORITY.reduce((recommendations, recommendationKey) => {
    const value = recommendationKey === 'language' ? getLang() : recommendationKey === 'country' || recommendationKey === 'industry' ? normalizedInsights[recommendationKey] : undefined;
    if (!value || typeof value !== 'string') {
      return recommendations;
    }
    const translationKey = buildRecommendationTranslationKey(recommendationKey, value);
    if (!translationKey) {
      return recommendations;
    }
    recommendations.push({
      recommendationKey,
      translatedValue: unescapedText(translationKey),
      value
    });
    return recommendations;
  }, []);
  return {
    data,
    loading
  };
}